export const IMAGES = {
  logo: {
    principal: '/images/global/brand/logo-js-empregos.png',
    light: '/images/global/brand/logo-js-empregos-light.png',
    dark: '/images/global/brand/logo-js-empregos-dark.png',
    fallback: '/images/global/brand/logo-js-empregos-fallback.png',
    sidebar: '/images/global/brand/sidebar-logo.svg',
    sidebarIcon: '/images/global/brand/sidebar-icon.svg',
    favicon: '/images/favicons/favicon-32x32.png',
  },
  hero: {
    background: '/images/home/hero/hero-profissional.svg',
    security: '/images/home/hero/hero-security.svg',
    overlay: '/images/home/hero/hero-overlay.svg',
    watermark: '/images/global/brand/watermark-logo.svg',
    grid: '/images/global/backgrounds/hero-grid.svg',
    lines: '/images/global/backgrounds/hero-lines.svg',
    cardheros: '/images/home/cards/cardheros.png',
    home: {
      slides: [
        '/images/home/banners/banner-principal.webp',
        '/images/home/banners/banner-secundario.webp',
        '/images/home/banners/banner-terciario.png',
      ],
      fallback: '/images/home/sections/fallback.svg',
    },
    servicos: {
      src: '/images/home/sections/servicos-hero.webp',
      fallback: '/images/home/sections/fallback.svg',
    },
    sobre: {
      src: '/images/hero/sobre/hero.svg',
      fallback: '/images/home/sections/fallback.svg',
    },
    trabalheConosco: {
      src: '/images/trabalhe-conosco/trabalhe-conosco.webp',
      fallback: '/images/home/sections/fallback.svg',
    },
    parceiros: {
      src: '/images/hero/parceiros/hero.svg',
      fallback: '/images/home/sections/fallback.svg',
    },
    fornecedores: {
      src: '/images/hero/fornecedores/hero.svg',
      fallback: '/images/home/sections/fallback.svg',
    },
    suporte: {
      src: '/images/suporte/hero/suporte.webp',
      fallback: '/images/home/sections/fallback.svg',
    },
    contato: {
      src: '/images/contato/contato.webp',
      fallback: '/images/home/sections/fallback.svg',
    },
    login: {
      src: '/images/login/herologin.jpg',
      fallback: '/images/home/sections/fallback.svg',
    },
  },
  services: {
    seguranca: '/images/servicos/seguranca.jpg',
    acesso: '/images/servicos/controle-acesso/controle-de-acesso.jpg',
    portaria: '/images/servicos/portaria/recepcao-e-portaria.jpg',
    limpeza: '/images/servicos/limpeza/limpeza.jpg',
    zeladoria: '/images/servicos/zeladoria/zeladoria-real.png',
    recepcao: '/images/servicos/portaria/recepcao-e-portaria.jpg',
    facilities: '/images/servicos/facilities/facilities-real.webp',
    monitoramento: '/images/servicos/controle-acesso/monitoramento.svg',
    recrutamento: '/images/servicos/recrutamento-selecao/recrutamento-alt.jfif',
    'assessoria-rh': '/images/servicos/assessoria-rh.png',
    'solucao-rh': '/images/servicos/solucao-rh.jfif',
    'time-rh': '/images/sobre/equipe/time-rh.jfif',
    facilitiesReal: '/images/servicos/facilities/facilities-real.webp',
    limpezaReal: '/images/servicos/limpeza/limpeza.jpg',
    jardinagemReal: '/images/servicos/jardinagem/jardinagem-real.webp',
    maoDeObraReal:
      '/images/servicos/mao-de-obra-temporaria/mao-de-obra-temporaria.jpg',
    terceirizacaoReal: '/images/servicos/terceirizacao/terceirizacao-real.webp',
    servicosReal: '/images/hero/servicos-hero.webp',
    zeladoriaReal: '/images/servicos/zeladoria/zeladoria-real.png',
    bancoTalentosReal: '/images/servicos/banco-talento.jfif',
    faxinaReal: '/images/servicos/faxina-diarista/faxina.webp',
    limpezaPesadaReal: '/images/servicos/limpeza-pesada/limpeza-pesada.webp',
    limpezaFachadaReal:
      '/images/servicos/limpeza-de-fachada/limpeza-de-fachada.webp',
    limpezaVidrosReal:
      '/images/servicos/limpeza-de-vidros/limpeza-de-vidros.webp',
    limpezaPreMudancaReal:
      '/images/servicos/limpeza-pre-mudanca/limpeza-pre-mudanca.webp',
    limpezaPosMudancaReal:
      '/images/servicos/limpeza-pos-mudanca/limpeza-pos-mudanca.webp',
    limpezaPosObraReal:
      '/images/servicos/limpeza-pos-obra/limpeza-pos-obra.webp',
    trabalhoTemporizadoReal: '/images/servicos/trabalho-terceirizado.png',
    trabalhoFreeLanceReal: '/images/servicos/trabalho-freelance.png',
  },
  partners: {
    vectorEngenharia: '/images/parceiros/vector-engenharia.webp',
    mistral: '/images/parceiros/mistral.webp',
    cadrempresaspareceiras:
      '/images/parceiros/cadastro-empresas-pareceiras.png',
  },
  empresas: {
    cadastro: '/images/empresas/hero/cadastro-empresas.png',
  },
  suporte: {
    hero: '/images/suporte/hero/suporte.webp',
  },
  trabalheConosco: {
    hero: '/images/trabalhe-conosco/trabalhe-conosco.webp',
  },
  backgrounds: {
    hero: '/images/global/backgrounds/waves.svg',
    pattern: '/images/global/backgrounds/pattern.svg',
    texture: '/images/global/backgrounds/grid.svg',
    heroGrid: '/images/global/backgrounds/hero-grid.svg',
    heroLines: '/images/global/backgrounds/hero-lines.svg',
  },
} as const;

export const HERO_IMAGES = [
  '/images/home/hero/hero-main.svg',
  '/images/home/hero/hero-security.svg',
] as const;
